import React from "react";
import HeroCardLayout from "../layout/HeroCardLayout";
import "../../styles/components/entryflow/LoadingUser.css";
import LoadingDots from "tenant/loading_dots.gif";

const LoadingUserComponent: React.FC = () => {
  return (
    <div className="loading-user-content">
      <img src={LoadingDots} alt="Loading..." className="entryflow-loading-image" />
    </div>
  );
};

const LoadingUserOnlyComponent: React.FC = () => {
  return (
    <HeroCardLayout>
      <LoadingUserComponent />
    </HeroCardLayout>
  );
};

export default LoadingUserComponent;
export { LoadingUserOnlyComponent };
